import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';
export function SimilarMarketsSectionSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-5 w-40" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-4" aria-busy="true">{t0}<div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3"><Skeleton className="h-32 rounded-panel-row" /><Skeleton className="h-32 rounded-panel-row" /><Skeleton className="h-32 rounded-panel-row" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}